<div class="h-100 d-flex flex-column justify-content-between">
  <div *ngIf="scoutPath && scoutPoint" class="modal-header flex-row justify-content-between"
  [style.backgroundColor]="scoutPoint.disabled?'lightgray !important':'white'">
    <div class="d-flex flex-column">
      <app-scout-header *ngIf="bReady" [scoutTaskDoc]="scoutTaskDoc" [scoutPath]="scoutPath" [scoutPoint]="scoutPoint"></app-scout-header>
      <div *ngIf="locked" class="d-flex flex-row mb-2 align-items-center" title="Parent scout is readonly (locked)">
        <div class="status-label p-2 mr-2" style="border-radius:4px;" [ngClass]="scoutPath.statusId|taskStatusBorderedCss">
          Scout Path {{scoutPath.statusId|taskStatusName|titlecase}}
        </div>
        <i class="fa fa-lock fa-2x mx-2"></i>
        <div class="text-secondary font-italic font-weight-bold">*** Read Only ***</div>
      </div>
    </div>

    <div class="d-flex flex-row">
      <div class="m-2" *ngIf="scoutPoint">
        <select id="disabled-select" class="disabled-label" title="Approved path point for test calls"
        [disabled]="!roleMgr.canEditUsers"
          [ngClass]="{disabled:6,enabled:3}[scoutPoint.disabled?'disabled':'enabled']|taskStatusBorderedCss"
          [(ngModel)]="scoutPoint.disabled" (ngModelChange)="onScoutPointDisabled($event)">
          <option class="enabled" [ngValue]="false">Testing Enabled</option>
          <option class="disabled" [ngValue]="true">Testing Disabled</option>
        </select>
      </div>
      <app-scout-point-paginator #scoutPointPaginator
        [scoutPath]="scoutPath"
        [skipViaPoints]="false"
        selectedOrderIndex="scoutPoint.order"
        [changeGuard]="changeSelectedPointGuard"
        (pointSelected)="setSelectedPoint($event)">
      </app-scout-point-paginator>
      <button type="button" class="align-self-start close" style="line-height: 1;" (click)="onCloseModal()">&times;</button>
    </div>
  </div>

  <div class="responsive-layout">
    <div *ngIf="scoutPath && scoutPoint" class="responsive-inner-layout">
      <div class="d-flex flex-wrap" style="width: calc(100% - 0px);">
        <div class="w-100 pb-2">
          <div id="scout-point-editor" class="d-flex flex-wrap-reverse justify-content-end p-1 w-100">
            <div *ngIf="scoutPoint.type!='VIA'" class="px-1 flex-grow-1" [ngClass]="locked?'disabled':''">
              <app-scout-point-environment #scoutPointEnvironment
                [scoutTaskDoc]="scoutTaskDoc"
                [scoutPath]="scoutPath"
                [scoutPoint]="scoutPoint"
                [isEditing]="isEditing"
                (editModeChanged)="onEnvEditorEditModeChanged($event)"
                [showTitlebar]="true"
                (editChange)="updateState()">
              </app-scout-point-environment>
            </div>
            <div class="px-sm-1 pt-1">
              <div class="d-flex flex-wrap">
                <div class="" [ngClass]="locked||!this.roleMgr.canEditUsers?'disabled':''">
                  <app-scout-point-error-calc #errorCalcComponent
                    [scoutPoint]="scoutPoint"
                    [isEditing]="isEditing"
                    (editModeChanged)="onErrorCalcEditModeChanged($event)"
                    (editChange)="onErrorCalcChanged($event)">
                  </app-scout-point-error-calc>
                </div>
                <div class="pl-2"  style="min-width:300px;" [ngClass]="locked?'disabled':''">
                  <app-scout-point-editor #scoutPointEditor
                    [buildingPoints]="buildingPoints"
                    [isEditing]="isEditing"
                    (editModeChanged)="onPointEditorEditModeChanged($event)"
                    [isLoadingBuildingPoints]="isLoadingBuildingPoints"
                    [scoutPoints]="scoutPath.scoutPoints"
                    [scoutPoint]="scoutPoint"
                    [showTitlebar]="true"
                    [showErrorCalcFields]="true"
                    [bearingDefaultAngles]="bearingDefaultAngles"
                    [locked]="locked"
                    (changed)="onScoutPointModified(scoutPoint)"
                    (formStatusChanged)="updateState()">
                  </app-scout-point-editor>
                </div>
              </div>
            </div>
          </div>
          <div class="pl-2" *ngIf="scoutPoint.type!='VIA'">
            <app-scout-point-ref-measurements #scoutPointRefMeasurements
              [showTitlebar]="true"
              [scoutTaskDoc]="scoutTaskDoc"
              [scoutPath]="scoutPath"
              [scoutPoint]="scoutPoint"
              [isEditing]="isEditing"
              [locked]="locked"
              [hidePhotos]="hidePhotos"
              (editModeChanged)="onMeasurementsEditModeChanged($event)"
              (editChange)="updateState()"
              (photoAdded)="onPhotoAdded($event)"
              (photoSaved)="updateState()">
            </app-scout-point-ref-measurements>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="bReady&&!bResizeMap" class="pl-1" [ngClass]="scoutPathPlotterCssClass">
      <app-scout-path-plotter #scoutPathPlotter
        [buildingPoints]="buildingPoints"
        [canSelectViaPoints]="true"
        [deletePointFn]="onDelete"
        (pointSelected)="setSelectedPoint($event)"
        [changeGuard]="changeSelectedPointGuard"
        [allowEditMode]="allowEditMode"
        [overlay]="scoutPath?.overlay"
        [locked]="locked"
        class="px-0">
      </app-scout-path-plotter>
      <div class="d-flex flex-row map-size-btn-grp" style="font-size:10px;">
        <button style="padding: 1px 2px;border:none;box-shadow: 0 0 1px 0 gray;" class="flex-fill" [disabled]="scoutPathPlotterCssClass=='small-plotter'" (click)="onResizeMap('small-plotter')">small</button>
        <button style="padding: 1px 2px;border:none;box-shadow: 0 0 1px 0 gray;" class="flex-fill" [disabled]="scoutPathPlotterCssClass=='medium-plotter'" (click)="onResizeMap('medium-plotter')">medium</button>
        <button style="padding: 1px 2px;border:none;box-shadow: 0 0 1px 0 gray;" class="flex-fill" [disabled]="scoutPathPlotterCssClass=='large-plotter'" (click)="onResizeMap('large-plotter')">large</button>
      </div>

      <div *ngIf="scoutPoint && scoutPoint.type!='VIA'"class="pt-2 small">
        <app-scout-point-photo-browser #photoBrowser
            [scoutTask]="scoutTaskDoc" [scoutPath]="scoutPath" [scoutPoint]="scoutPoint"
            [groupSelectEnabled]="true"
            (photoSelected)="onPhotoSelected($event)"
            (photoGroupSelected)="onPhotoGroupSelected($event)"
            [locked]="locked"
            [newPhotoFn]="scoutPointRefMeasurements?.onNewPhoto">
        </app-scout-point-photo-browser>
      </div>
    </div>
  </div>

  <div class="modal-footer d-flex flex-wrap justify-content-between">
    <div class="d-flex flex-row">
      <div class="bg-dark px-1" style="border-radius:3px;">
        <app-scout-photos-status-bar [hideOthers]="true"></app-scout-photos-status-bar>
      </div>
      <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </div>
    <div>
      <div *ngIf="!isEditing">
        <button [disabled]="!allowEditMode || locked" [ngClass]="locked?'disabled':''" class="m-sm-1 btn btn-sm btn-info" (click)="onEdit()" title="Edit"><i class="fa fa-edit"></i>&nbsp;Edit</button>
        <button type="button" class="m-sm-1 btn btn-sm btn-primary" (click)="onCloseModal()">Close</button>
      </div>
      <div *ngIf="isEditing" class="d-flex flex-row small">
        <button [disabled]="!bIsModified || !bIsValid || bIsSaving " class="m-sm-1 btn btn-sm btn-info" (click)="onSave()"><i class="fa fa-save"></i>&nbsp;Save</button>
        <button class="m-sm-1 btn btn-sm btn-warning" (click)="onCancel()">&nbsp;Cancel</button>
      </div>
    </div>
  </div>
</div>
